export enum OfferEditFieldEnum {
  Status = 'status',
  AssignedValue = 'assignedValue',
  Note = 'note',
  CloseReason = 'closeReason',
  SerialNumber = 'serialNumber',
}
